import React from "react";

export interface SortItem {
  value: string;
  label: string;
  selected: boolean;
}

const Sorter = ({
  items,
  onSort,
}: {
  items: SortItem[];
  onSort: (value: string) => void;
}) => {
  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSort(event.target.value);
  };

  return (
    <div className="p-1 border flex items-center rounded outline-none text-xs">
      <span className="mr-1 font-medium">Sort By:</span>
      <select
        defaultValue={items.filter((item) => item.selected)[0].value}
        onChange={handleSortChange}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Sorter;
